import { Account } from "../types";

export const login = request => ({ type: Account.LOGIN, request });

export const setLoading = loading => ({ type: Account.SET_LOADING, loading });

export const setUser = user => ({ type: Account.SET_USER, user });
